<template>
    <v-dialog v-model="dialog" persistent max-width="330">
        <template v-slot:activator="{ on }">
            <div class="action" v-on="on">
            <font-awesome-icon class="delete" icon="trash-alt" />
            <p>Delete Team</p>
            </div>
        </template>
        <v-card class="modal">
            <v-card-title>
                <font-awesome-icon
                    class="delete_header"
                    icon="info-circle"
                />
                <p>Team Delete Confirmation</p>
            </v-card-title>
            <v-card-text v-if="this.team_id != undefined && this.team_id != ''">
                Are you sure you want to <span class="bold">delete</span> this team <span class="bold">forever</span>?                
            </v-card-text>
            <v-card-text v-else>
                Please select a team first.
            </v-card-text>
            <v-card-actions v-if="this.team_id != undefined && this.team_id != ''">
                <v-btn small class="delete" @click="deleteTeam()">Yes</v-btn>
                <v-btn small class="cancel" @click="dialog = false">No</v-btn>
            </v-card-actions>
            <v-card-actions v-else>
                <v-btn small class="cancel" @click="dialog = false">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['team_id'],
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        deleteTeam() {
            const data = {
                team_id: this.team_id
            };
            this.$store.dispatch("deleteTeam", data).then(response => {
                this.$store.dispatch("getAllTeams");
                this.$store.dispatch("getAllUsers");
                this.$store.dispatch("aboutMe");
                this.dialog = false;
            }).catch(() => {
                this.dialog = false;
            });
        },
    }
}
</script>